const styles = (theme) => ({
  hover: {
    cursor: 'pointer',
  },
  idCell: {
    minWidth: theme.spacing(5),
  },
  selectedRow: {
    background: theme.palette.grey[100],
  },
});

export default styles;
